import { Filters } from '@/types/filters';

const removeFilter = ({
  activeFilters,
  filterName,
  filterValue,
  setFilters,
  values
}: {
  activeFilters: Partial<Filters>;
  filterName: string;
  filterValue: string;
  setFilters: (filters: Partial<Filters>) => void;
  values: Partial<Filters>;
}) => {
  if (typeof values[filterName] === 'string') {
    return setFilters({
      ...activeFilters,
      [filterName]: ''
    });
  }

  // If filter is a list of strings, remove the value in the array
  const filterList = values[filterName];
  if (filterList) {
    const index = filterList?.indexOf(filterValue);
    if (index || index === 0) {
      (filterList as string[]).splice(index, 1);

      return setFilters({
        ...activeFilters,
        [filterName]: filterList
      });
    }
  }
};

export default removeFilter;
